import { useThumbnailPoller } from './hooks';
import { Asset, AssetWithDimensions } from './types';

export type AssetLibraryGalleryGridItemMissingThumbnailProps = {
    asset: Asset | AssetWithDimensions;
};

export function AssetLibraryGalleryGridItemMissingThumbnail({
    asset,
}: AssetLibraryGalleryGridItemMissingThumbnailProps): null {
    useThumbnailPoller(asset);
    return null;
}
AssetLibraryGalleryGridItemMissingThumbnail.displayName = 'AssetLibraryGalleryGridItemMissingThumbnail';
